import { Checkbox } from '@mantine/core';
import { EventTypeFilter } from '../types';

export const EventTypeFilters: React.FC<{
  event: EventTypeFilter;
  allEvents: EventTypeFilter[];
  onChange: (events: EventTypeFilter[]) => void;
}> = ({ event, allEvents, onChange }) => {
  return (
    <Checkbox
      label={event.label.toLowerCase()}
      checked={event.value}
      onChange={(e) => {
        const updatedEvents = allEvents.map((prevEvent) => {
          if (prevEvent.label === event.label) {
            return { ...prevEvent, value: e.target.checked };
          }
          return prevEvent;
        });
        onChange(updatedEvents);
      }}
      styles={{
        label: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          textTransform: 'capitalize',
          paddingLeft: '4px',
        },
      }}
    />
  );
};
